import React from 'react';
import { NavDropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function DropdownItem({ title, link }) {
  return (
    <>
      <NavDropdown.Item>
        <Link to={link} className='navLink'>
          <p>{title}</p>
        </Link>
      </NavDropdown.Item>
      <NavDropdown.Divider />
    </>
  );
}

export default DropdownItem;
